/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  query PlatformReadQuery {
    PlatformRead {
      invoiceSmtpConfiguration,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
